import ApiService from '@/services/api.service';

const state = {
    eventsBalance: [],
    refCode: '',
    url_ref: '',
};

const getters = {
    eventsBalance: state => state.eventsBalance,
    url_ref: state => state.url_ref,
    refCode: state => state.refCode,
    getRefCode: state => state.refCode,
};

const actions = {
    setRefCode({ commit }, payload) {
        commit('SET_REF_CODE', payload);
    },
    getEventsBalance(context) {
        return ApiService.get('events/balance/')
            .then(response => {
                context.commit('setEventsBalance', response.data.results);
                context.commit('setEventsRef', response.data.url_ref);

                const urlParams = new URLSearchParams(window.location.search);
                const refCode = urlParams.get('ref_code');
                if (refCode) {
                    localStorage.setItem('url_ref', refCode);
                }

                if (refCode) {
                    localStorage.setItem('url_ref', urlRef);
                    localStorage.setItem('ref_code', refCode);
                }

                if (refCode) {
                    context.dispatch('postSendRefCode', refCode);
                }
            })
            .catch(error => {
                console.log(error);
            });
    },
    postSendRefCode(context, refCode) {
        return new Promise((resolve, reject) => {
            ApiService.post('/api/send_ref_code/', { ref_code: refCode })
                .then(response => {
                    if (response.data.status === 'ok') {
                        context.commit('SET_REF_CODE', refCode);
                        console.log(response.data);
                        resolve();
                    } else {
                        console.log('ref_code равен null');
                        reject();
                    }
                })
                .catch(error => {
                    console.log(error);
                    reject();
                });
        });
    },
};

const mutations = {
    setEventsBalance(state, payload) {
        state.eventsBalance = payload;
    },
    setEventsRef(state, payload) {
        state.url_ref = payload;
    },
    SET_REF_CODE(state, payload) {
        state.refCode = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
